import { Box, Typography } from "@mui/material";
import { ReactElement } from "react";
import { Control } from "react-hook-form";

import { RhfSwitchField } from "~frontend/components/forms/react-hook-form-components";

export function scopesToValue({
  allScopes,
  selectedScopes,
}: {
  allScopes: string[];
  selectedScopes: string[];
}): { [scope: string]: boolean } {
  return Object.fromEntries(
    allScopes.map(scope => [scope, selectedScopes.includes(scope)])
  );
}

export function valueToScopes({
  allScopes,
  formValue,
}: {
  allScopes: string[];
  formValue: { [scope: string]: boolean };
}): string[] {
  return allScopes.filter(scope => !!formValue[scope]);
}

export default function RhfApiKeyScopesField({
  control,
  scopes,
  label,
  namePrefix,
}: {
  control: Control<any>;
  scopes: string[];
  label: string;
  namePrefix: string;
}): ReactElement {
  return (
    <Box>
      <Box>
        <Typography variant="body2Bold">{label}</Typography>
      </Box>
      <Box>
        <Typography variant="body2" color="textSecondary">
          Select the scopes this API key should have access to. Scopes allow you
          to control which API endpoints this key will be able to use. Refer to
          the API documentation for which scopes are required for each endpoint.
        </Typography>
      </Box>
      <Box sx={{ columns: 3 }}>
        {scopes.map(scope => (
          <Box key={scope}>
            <RhfSwitchField
              control={control}
              name={`${namePrefix}.${scope}`}
              label={scope}
            />
          </Box>
        ))}
      </Box>
    </Box>
  );
}
